import { FC, MouseEvent } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Stack, Typography } from '@mui/material'
import { LabeledText } from '../../../../../../components/CustomTypography'
import { FoundationDescription } from '../../../../../../components/PrivateFoundationDetail'
import { StyledCard } from '../../../../../../components/StyledCard'
import { AccordionIcon } from './AccordionIcon'
import { PFGrantsTable } from './PFGrantsTable'

interface PFAccordionProps {
  title: string
  website: string
  taxYear: string
  grants: any[]
  description: string
  financialContributions: string
  handleGrantFormSlideOut: (e:MouseEvent<HTMLElement>) => void
}

const Table_Header = ['Grant name', 'Amount', 'Due date']

export const PFAccordion: FC<PFAccordionProps> = ({ title, grants, website, taxYear, description, financialContributions, handleGrantFormSlideOut }) => {
  return <StyledCard sx={{ py: 1, px: 2, mb: 2 }}>
    <Accordion
      elevation={0}
      sx={{
        p: 0,
        background: 'transparent',
        transformOrigin: 'top',
        '&::before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        sx={{
          p: 0,
          alignSelf: 'flex-start',
          '& .MuiAccordionSummary-expandIconWrapper': {
            mt: 1.5,
            alignSelf: 'flex-start',
          },
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            mt: 2.5,
          },
        }}
        expandIcon={<AccordionIcon/>}
      >
        <Stack gap={2} width="100%">
          <Stack direction='row' justifyContent="space-between">
          <Typography color="secondary" fontSize="0.9rem" fontWeight={600}>
            {title}
          </Typography>

            <Button
             variant='contained'
             disableElevation={true}
             onClick={handleGrantFormSlideOut}
             sx={{
               mr:2,
               borderRadius:"8px",
               fontSize: "0.875rem",
               textTransform: "none"
             }}
            >
              Add Grant
            </Button>
          </Stack>

          <Grid container spacing={2}>
            <Grid item sm={4} xs={12}>
              <LabeledText
                label="Financial contribution"
                value={`$${financialContributions}`}
                labelProps={{ fontSize: '0.875rem' }}
                valueProps={{ fontSize: '0.875rem', fontWeight: 500 }}
                rootContainerProps={{ direction: 'column', alignItems: 'flex-start' }}
              />
            </Grid>

            <Grid item sm={4} xs={12}>
              <LabeledText
                label="Website"
                value={website}
                labelProps={{ fontSize: '0.875rem' }}
                valueProps={{ fontSize: '0.875rem', fontWeight: 500 }}
                rootContainerProps={{ direction: 'column', alignItems: 'flex-start' }}
              />
            </Grid>

            <Grid item sm={4} xs={12}>
              <LabeledText
                label="Tax year"
                value={taxYear}
                labelProps={{ fontSize: '0.875rem' }}
                valueProps={{ fontSize: '0.875rem', fontWeight: 500 }}
                rootContainerProps={{ direction: 'column', alignItems: 'flex-start' }}
              />
            </Grid>
          </Grid>
        </Stack>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0 }}>
        <Stack gap={2}>
          <FoundationDescription description={description} />

          {!!grants.length && <PFGrantsTable grants={grants} tableHeader={Table_Header}/>}
        </Stack>
      </AccordionDetails>
    </Accordion>
  </StyledCard>
}